import { useEffect, useRef, useState, useCallback } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

import { GridPaginationModel } from '@mui/x-data-grid-pro';

export const useGridPagination = (initialPageSize?: number) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const hasPageInUrl = searchParams.has('page');
  const pageFromUrl = parseInt(searchParams.get('page') || '1', 10);

  const [page, setPage] = useState<number>(hasPageInUrl ? pageFromUrl : 1);
  const [pageSize, setPageSize] = useState<number | undefined>(initialPageSize);
  const shouldSyncUrl = useRef<boolean>(false);

  const updatePageInUrl = useCallback(
    (updatedPage: number) => {
      const newParams = new URLSearchParams(searchParams);
      newParams.set('page', updatedPage.toString());
      navigate({ search: newParams.toString() }, { replace: true });
    },
    [searchParams, navigate],
  );

  useEffect(() => {
    if (!shouldSyncUrl.current) return;
    updatePageInUrl(page);
  }, [page, updatePageInUrl]);

  const handlePageChange = ({
    page: newPage,
    pageSize: newPageSize,
  }: GridPaginationModel) => {
    const nextPage = newPage + 1;
    setPage(nextPage);
    setPageSize(newPageSize);
    shouldSyncUrl.current = true;
  };

  return { page, pageSize, handlePageChange };
};
